import React from 'react';


export default function FieldBooleanViewInImport(props) {

    return (
        <div className="ui5-txt-default-small">
            {!!props.value?'True':'False'}
        </div>
    );
}